import { inject, Injectable } from '@angular/core';
import type { Album, AlbumData, UserCameras } from '@hunting-nature/shared-core/interfaces/album.interface';
import { ActionSheetController } from '@ionic/angular/standalone';
import { TranslocoService } from '@jsverse/transloco';
import { map, type Observable } from 'rxjs';

import { uniqueAlbums } from '../../../shared/helper/album.helper';
import { GalleryService, INITIAL_PAGINATION_LIMIT_CAMERA_ALBUMS } from '../image-gallery/services/gallery.service';

@Injectable({
  providedIn: 'root',
})
export class GalleryPageService {
  // services
  private readonly galleryService = inject(GalleryService);

  /* public getOwnCamerasAlbums$(startIndex: number = 0, limit?: number): Observable<AlbumData> {
    return this.galleryService.getAlbumsFromCamerasUserCanAccess$(startIndex, limit).pipe(
      map((camerasUserCanAccess: { ownCameras: Array<Album>; sharedCameras: Array<Album>; servicePlanCameras: Array<Album> }) => {
        return {
          albums: uniqueAlbums([...camerasUserCanAccess.ownCameras, ...camerasUserCanAccess.servicePlanCameras]),
          totalNoAlbums: 0, // TODO!
        } as AlbumData;
      })
    );
  }

  public getSharedWithUSerCameraAlbums$(startIndex: number = 0, limit?: number): Observable<AlbumData> {
    return this.galleryService.getAlbumsFromCamerasUserCanAccess$(startIndex, limit).pipe(
      map((camerasUserCanAccess: { ownCameras: Array<Album>; sharedCameras: Array<Album>; servicePlanCameras: Array<Album> }) => {
        return {
          albums: camerasUserCanAccess.sharedCameras,
          totalNoAlbums: 0, // TODO!
        } as AlbumData;
      })
    );
  } */

  public getOwnAndSharedCameraAlbums$(startIndex: number = 0, limit: number = INITIAL_PAGINATION_LIMIT_CAMERA_ALBUMS): Observable<UserCameras> {
    return this.galleryService.getAlbumsFromCamerasUserCanAccess$(startIndex, limit).pipe(
      map(
        (camerasUserCanAccess: {
          ownCameras: Array<Album>;
          sharedCameras: Array<Album>;
          servicePlanCameras: Array<Album>;
          totalNumberOfOwnAndSharedCameras: number;
        }) => {
          return {
            sharedCameras: camerasUserCanAccess.sharedCameras,
            ownCameras: uniqueAlbums([...camerasUserCanAccess.ownCameras, ...camerasUserCanAccess.servicePlanCameras]),
            totalNumberOfOwnAndSharedCameras: camerasUserCanAccess.totalNumberOfOwnAndSharedCameras,
          } as UserCameras;
        }
      )
    );
  }
}
